import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import { WatchlistWithChildLists } from '../model/watchlist/watchlist-with-child-lists';
import { Watchlist } from '../model/watchlist/watchlist';


/**
 * Represents a list of watchlists
 */
@Component({
  selector: 'p1-watchlists-list',
  templateUrl: 'watchlists-list.component.html',
  styleUrls: ['watchlists-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WatchlistsListComponent {

  @Input()
  watchlists: WatchlistWithChildLists[] = [];

  @Input()
  detailPageLinkPrefix: string = '';

  @Input()
  openDetailInNewTab: boolean = false;

  @Input()
  maxPreviewCount: number;

  @Input()
  canRemove: boolean;

  @Input()
  canEdit: boolean;

  @Input()
  canShare: boolean;

  @Output()
  editWatchlist: EventEmitter<Watchlist> = new EventEmitter<Watchlist>();

  @Output()
  removeWatchlist: EventEmitter<Watchlist> = new EventEmitter<Watchlist>();

  @Output()
  shareWatchlist: EventEmitter<Watchlist> = new EventEmitter<Watchlist>();


  constructor() {}

  get sortedWatchlists() {
    return this.watchlists.sort((elementA, elementB) => elementB.lastModified > elementA.lastModified ? 1 : -1);
  }


  identifyWatchlist(_, watchlist: Watchlist) {
    return watchlist.uuid;
  }
}
